<template>
  <div>
    <el-card class="box-card" style="min-height: 700px">
        <span slot="header">采摘计划</span>
    <el-row :gutter="10">
      <el-col :span="5">
        <el-form :model="filter" label-position="top" ref="filter">
          <el-form-item label="园区" prop="parkId" size="small">
            <!-- 园区选框 -->
            <el-select
              v-model="filter.parkId"
              clearable
              placeholder="请选择园区"
            >
              <el-option
                v-for="p in parks"
                :key="p.id"
                :label="p.name"
                :value="p.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="19">
        <el-empty v-show="total==0" description="暂无数据"></el-empty>
        <div>
          <el-steps direction="vertical" :active="1">
            <el-step
              v-for="(item,index) in harvestList"
              :key="index"
              :title="new Date(item[0].date).format('yyyy-MM-dd')"
            >
              <template slot="description">
                <div style="display: flex">
                  <el-card v-for="(ite,inde) in item" :key="inde">
                    <p>{{ite.parkName}}</p>
                    <p>{{ite.landName}}</p>
                    <p>{{ite.variName}}</p>
                  </el-card>
                </div>
              </template>
            </el-step>
          </el-steps>
          <el-divider v-if="total>0" content-position="center">
            <el-button v-if="count<total" type="primary" @click="more">加载更多</el-button>
            <span v-else style="color: gray">已经到底了</span>
          </el-divider>
        </div>
      </el-col>
    </el-row>
      </el-card>
  </div>
</template>

<script>
  import { getParksInEnterprise } from '@/api/park2.js'
  import { getHarvestPlan } from '@/api/harvest.js'
export default {
  name: 'HarvestPlan',
  components: {},
  data() {
    return {
      filter: {
        parkId: undefined,
        to: undefined,
      },
      harvestId: undefined,
      pageNum: 1,
      value: 0,
      total: 0,
      num:3,
      count:0,
      searchContent: null,
      activate: '3-3',
      tableData: [],
      activeTab: 'newone',
      parks:[],
      harvestList:[],

    }
  },
  computed: {
    title: function () {
      return this.harvestId ? '编辑' : '新增'
    },
    enterpriseId:function () {
      return this.$store.getters.currentEnterprise.id
    }
  },
  methods: {
    more() {
      this.num+=1
      this.harvestSearch()
    },
    searchSubmit() {
      this.num=3
      this.harvestSearch()
    },
    harvestSearch() {
      console.log('查询')
      let option = {
        pageNum: this.pageNum,
        pageSize: this.value,
        parkId:this.filter.parkId
      }
      getHarvestPlan(this.enterpriseId,option).then((data) => {
        let arr = data.data.list
        let num=0
        this.total=data.data.list.length
        this.harvestList=[]
        this.count=0
        for(let i=0;i<arr.length;i++) {
          if(i==0){
           this.harvestList[num]=[]
            this.harvestList[num].push(arr[i])
          }else{
            if(this.harvestList[num][0].date==arr[i].date){
              this.harvestList[num].push(arr[i])
            }else{
              num++;
              this.harvestList[num]=[]
              this.harvestList[num].push(arr[i])
            }
          }
        }
        this.harvestList=this.harvestList.filter((item,index)=>{
          return index < this.num
        })
        this.harvestList.forEach(item=>{
          this.count+=item.length
        })
      })
    },
    cancel() {
      // this.$refs.harvestAdd.clearFrom()
      // this.harvestId=undefined
      // this.$refs.harvestAdd.form.id=undefined
    },
    editor(row) {
      this.harvestId = row.id
      Object.keys(this.$refs.harvestAdd.form).forEach((key) => {
        this.$refs.harvestAdd.form[key] = row[key]
      })
      this.$refs.harvestAdd.form.enterpriseId = this.enterpriseId
    },
    handleSizeChange(val) {
      this.value = val
      this.pageNum = 1
      this.PlanDataGet()
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.PlanDataGet()
      console.log(`当前页: ${val}`)
    },
    newPlan() {
      if (this.harvestId) {
        this.harvestId = undefined
        this.$refs.harvestAdd.save()
      }
    },
    showactivate(a) {
      console.log('a', a), (this.activate = a)
      //  (this.activate = a)
    },
  },
  mounted() {
    // 初始化园区下拉框
    getParksInEnterprise(this.enterpriseId).then((resp) => {
      this.parks = resp.data
    })
    this.harvestSearch()
  },
  filters: {
    statusString(value) {
      if (value == 0) {
        return '任务待处理'
      } else if (value == 1) {
        return '任务已完成'
      }
    },
    timeString: function (t) {
      console.log(t)
      let d = new Date(t)
      let month = d.getMonth() + 1 < 9 ? `0${d.getMonth() + 1}` : d.getMonth()
      let day = d.getDate() + 1 < 10 ? `0${d.getDate()}` : d.getDate()
      let hour = d.getHours() < 10 ? `0${d.getHours()}` : d.getHours()
      let minutes = d.getMinutes() < 10 ? `0${d.getMinutes()}` : d.getMinutes()
      let second = d.getSeconds() < 10 ? `0${d.getSeconds()}` : d.getSeconds()
      return `${d.getFullYear()}-${month}-${day}`
    },
  },
  beforeDestroy() {},
}
</script>

<style scoped>
.employListbox {
  background: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  padding: 8px;
  min-height: 603px;
}
.cardTitle {
  margin-top: 0px;
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/product/plan/Harvest.vue